import $ from 'jquery';

$(function () {
    $('[data-toggle="popover"]').popover();
});
